import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import './styles/tae.css';
import TopTitle from './Pc_TopTitle';
import KeywordSearch from './components/EventNotice/KeywordSearch';
import EventList from './components/EventNotice/EventList';
import { instance } from './common';

function EventNotice() {
  const [keyword, setKeyword] = useState('');
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const obj = {
      page: page,
      ppp: 6,
      value: 'e_title',
      keyword: keyword,
    };

    // fetch data
    instance.post('/event/event_all', obj).then(function (res) {
      // console.log('res.data : ', res.data);
      setData(res.data.rows);
      setTotal(res.data.totalPage);
    });
  }, [page, keyword]);

  const pageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  return (
    <main>
      <Container>
        <TopTitle title="이벤트" />
        <KeywordSearch onSearchHandler={setKeyword} />
        <EventList data={data} />
        <section className="wrap-page">
          <Pagination
            activePage={page}
            itemsCountPerPage={6}
            totalItemsCount={total}
            pageRangeDisplayed={10}
            onChange={pageChange}
          />
        </section>
      </Container>
    </main>
  );
}

export default EventNotice;
